export const eboStoreDrawerElements = {
	store_details: {
		name: "Store Details",
		key: "store_details",
		display: true,
	},
	finance_details: {
		name: "Finance Details",
		key: "finance_details",
		display: true,
	},

	project_detials: {
		name: "Project Details",
		key: "project_details",
		display: true,
	},
	employee_details: {
		name: "Employee Details",
		key: "employee_details",
		display: true,
	},
	loi_files_details: {
		name: "File Details",
		key: "loi_files_details",
		display: true,
	},
};
